import React, { useCallback, useEffect, useRef } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import EmbeddedApp from '../components/EmbeddedApp';
import { learningService } from '../services/api';

// Розділи «Навчання NEW» — підпункти меню ЕРП (/learning/<розділ> → сторінка сервісу).
const SECTIONS = ['courses', 'tests', 'results', 'make-quiz', 'settings'];

// Подія для меню ЕРП: лічильники нових курсів/тестів { '/courses': n, '/tests': n }
export const LEARNING_BADGES_EVENT = 'replast:learning-badges';

// «Навчання NEW» — окремий сервіс курсів і тестів (learning/), вбудовується в робочу область ЕРП.
// Бекенд видає одноразове посилання входу під поточним співробітником.
function LearningPage() {
  const { section } = useParams();
  const originRef = useRef('');

  const getLoginUrl = useCallback(async () => {
    const res = await learningService.login(`/${section}`);
    originRef.current = new URL(res.data.url).origin;
    return res;
  }, [section]);

  // Лічильники приймаємо лише від сервісу навчання (origin iframe)
  useEffect(() => {
    const onMessage = (e) => {
      if (e.origin !== originRef.current || e.data?.type !== 'replast-learning-badges') return;
      window.dispatchEvent(new CustomEvent(LEARNING_BADGES_EVENT, { detail: e.data.badges || {} }));
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  if (!SECTIONS.includes(section)) return <Navigate to="/learning/courses" replace />;

  return (
    <EmbeddedApp
      key={section}
      title="Навчання NEW"
      getLoginUrl={getLoginUrl}
      errorText="Не вдалося відкрити навчання."
    />
  );
}

export default LearningPage;
